(() => {
  const header = document.querySelector('.page-header');
  if (!header) return;
  const bars = [...document.querySelectorAll('[class*="ai-announcement-marquee-"][class$="__bar"]')];
  const update = () => {
    const bottom = bars.reduce((value,bar) => getComputedStyle(bar).position === 'fixed' ? Math.max(value,bar.getBoundingClientRect().bottom) : value,0);
    header.style.setProperty('--miez-header-offset', Math.max(0,bottom) + 'px');
  };
  const observer = new ResizeObserver(update);
  bars.forEach(bar => observer.observe(bar));
  window.addEventListener('resize',update);
  update();
})();
